<template>
  <div style="height: 100%">
    <div class="table-row">
      <div class="table-col table-box">
        <div class="right-title">身份标签</div>
        <table border="1" style="border-collapse: collapse; width: 100%">
          <tr>
            <th class="table-title">企业性质</th>
            <th colspan="2">{{ form.firmProperty }}</th>
          </tr>
          <tr>
            <td class="table-title">企业行业</td>
            <td>{{ form.industryType }}</td>
          </tr>
          <tr>
            <td class="table-title">经营年限</td>
            <td colspan="2">{{ form.businessYears }}</td>
          </tr>
          <tr>
            <td class="table-title">发展阶段</td>
            <td colspan="2">{{ form.developePhase }}</td>
          </tr>
        </table>
      </div>
      <div class="table-col table-box">
        <div class="right-title">特征标签</div>
        <table border="1" style="border-collapse: collapse; width: 100%">
          <tr>
            <th class="table-title">企业规模</th>
            <th colspan="2">{{ form.firmSize }}</th>
          </tr>
          <tr>
            <td class="table-title">业务发展</td>
            <td>{{ form.businessDevelopment }}</td>
          </tr>
          <tr>
            <td class="table-title">行业地位</td>
            <td colspan="2">{{ form.industryPosition }}</td>
          </tr>
        </table>
      </div>
      <div class="table-col table-box">
        <div class="right-title">品质标签</div>
        <table border="1" style="border-collapse: collapse;width: 100%">
          <tr>
            <th class="table-title">企业管理</th>
            <th colspan="2">{{ form.firmManage }}</th>
          </tr>
          <tr>
            <td class="table-title">纳税信用</td>
            <td>{{ form.taxCredit }}</td>
          </tr>
          <tr>
            <td class="table-title">央行征信</td>
            <td colspan="2">{{ form.bankCredit }}</td>
          </tr>
          <tr>
            <td class="table-title">司法官司</td>
            <td colspan="2">{{ form.justiceLawsuit }}</td>
          </tr>
          <tr>
            <td class="table-title">工商行政</td>
            <td colspan="2">{{ form.administration }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: Object
  }
};
</script>

<style scoped lang="scss">
table {
  margin: 0.1rem 0;
  th,
  td {
    padding: 0.05rem;
    text-align: center;
    color: #fff;
    border-color: rgba(39, 245, 255, 0.5);
  }

  .table-title {
    background: rgba(39, 245, 255, 0.05);
  }
}
.right-title {
  border-left: 2px solid #01c5f3;
  padding: 0 0.1rem;
  font-size: 0.12rem;
  font-weight: 550;
}
 .table-box {
    border: 1px solid #01c5f3;
    padding: 0.05rem;
  }
.table-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  height: 100%;
  .table-col {
    box-sizing: border-box;
    width: calc(50% - 0.05rem);
    height: calc(50% - 0.05rem);
  }
  .table-col:nth-of-type(3){
    margin-top: 0.1rem;
  }
}
</style>
